export abstract class BaseParameter {
  abstract parse(value: string): void;
  abstract get isValid(): boolean;
  abstract format(): string;
}

export class NumberParameter implements BaseParameter {
  value: number;
  constructor(
    public defaultValue: number,
    private decimalPoints: number
  ) {
    this.value = defaultValue;
  }

  parse(value: string): void {
    const parsed = parseFloat(value);
    this.value = Number.isNaN(parsed) ? Number.NaN : parsed;
  }

  get isValid(): boolean {
    return !Number.isNaN(this.value);
  }

  format(): string {
    return this.isValid ? this.value.toFixed(this.decimalPoints) : '';
  }
}

export class BooleanParameter implements BaseParameter {
  value: boolean;
  constructor(public defaultValue: boolean) {
    this.value = defaultValue;
  }

  parse(value: string | boolean): void {
    if (typeof value === 'boolean') {
      this.value = value;
      return;
    }
    this.value = value === 'true';
  }

  get isValid(): boolean {
    return true;
  }

  format(): string {
    return this.value.toString();
  }
}

export const DEFAULT_WHEEL_PARAMETERS = {
  rimErd: new NumberParameter(495, 1),
  rimNumHoles: new NumberParameter(32, 0),
  rimDrillingOffsetDs: new NumberParameter(0, 1),
  rimDrillingOffsetNds: new NumberParameter(0, 1),
  rimFlipOffsetOrder: new BooleanParameter(false),
  dsFlangePcd: new NumberParameter(35, 1),
  ndsFlangePcd: new NumberParameter(35, 1),
  dsFlangeOffset: new NumberParameter(35, 1),
  ndsFlangeOffset: new NumberParameter(35, 1),
  dsFlangeNumHoles: new NumberParameter(16, 0),
  ndsFlangeNumHoles: new NumberParameter(16, 0),
  hubRotation: new NumberParameter(0.25, 2),
  dsNdsOffset: new NumberParameter(0.5, 2),
  spokeHoleDiameter: new NumberParameter(2.6, 1),
  spokeGroupingPrecision: new NumberParameter(1, 1),
};

export const DEFAULT_VIEW_PARAMETERS = {
  realisticScale: new BooleanParameter(false),
  ndsView: new BooleanParameter(false),
  angleThreshold: new NumberParameter(10, 0),
};

export type WheelParameters = typeof DEFAULT_WHEEL_PARAMETERS;
export type ViewParameters = typeof DEFAULT_VIEW_PARAMETERS;

export const validateParameters = (parameters: WheelParameters | ViewParameters): boolean => {
  for (const parameter of Object.values(parameters)) {
    if (!parameter.isValid) return false;
  }
  return true;
};
